import React from 'react'

function PeerSupport() {
  return (
    <div>PeerSupport</div>
  )
}

export default PeerSupport